import ErrorBoundary from './ErrorBoundary';
import { withRouter } from 'react-router';

// @ts-ignore
export default withRouter(ErrorBoundary);
